export default __webpack_public_path__ + "static/media/ipX7.06f5befd.svg";